module.exports = __webpack_public_path__ + "img/bg_function01_3_t.b8da88f9.png";